import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Column from '../core/Column';
import Container from '../core/Container';
import Row from '../core/Row';
import Dashboard from './Dashboard';
import CreateForm from './CreateForm';
import EditForm from './EditForm';
import Leads from './Leads';
import Settings from './Settings';
import Analytics from './Analytics';

// Default Styles
import '../styles/main.scss';
import TabComponent from './TabComponent';
import FormPreset from './FormPreset';

function App() {
	return (
		<>
			<Container>
				<Row>
					<Column xs="12">

						<Routes>
							<Route
								path="/"
								element={<Dashboard />}
							/>
							<Route
								path="/create-form"
								element={<CreateForm />}
							/>

							<Route
								path="/preset-form"
								element={<FormPreset />}
							/>

							<Route
								path="/edit/:id"
								element={<EditForm />}
							/>

							<Route
								path="/Leads"
								element={<TabComponent />}
							/>

							<Route
								path="/SCFLeads"
								element={<Leads />}
							/>

							<Route
								path="/analytics"
								element={<Analytics />}
							/>

							<Route
								path="/settings"
								element={<Settings />} />

						</Routes>

						<ToastContainer
							position="top-right"
							autoClose={2000}
							hideProgressBar={true}
							newestOnTop={false}
							closeOnClick={false}
							rtl={false}
							pauseOnFocusLoss={true}
							pauseOnHover={true}
							theme="colored"
						/>
					</Column>
				</Row>
			</Container>
		</>
	);
}

export default App;
